module.exports = __webpack_public_path__ + "static/media/0028_Small.770032b8.jpg";